import { TSelectOptionType } from '@components/common/Select/Select.types';

export const getChangedValues = (
	clickedOptions: Array<TSelectOptionType>,
	existedOptions: Array<TSelectOptionType>,
): TSelectOptionType[] => {
	return clickedOptions.reduce((acc, option) => {
		if (existedOptions.some((existedOption) => existedOption?.value === option?.value)) {
			return acc.filter((existedOption) => (existedOption?.value !== option?.value));
		}

		return [...acc, option];
	}, existedOptions);
};

